//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from "../../transitions/Expand.vue";
export default {
  name: "BlueFilterItem",
  components: { TransitionExpand },
  props: ["filter", "setFilterValue", 'disable'],
  data() {
    return {
      active: false,
    };
  },
  computed: {
    disableChildren() {
      return !!(this.options.filterParentsExcludeChildren && ((this.hasChildren && this.model) || (this.disable)));
    },
    disabled() {
      return this.disable || false;
    },
    hasChildren() {
      return !!(this.filter.filters && this.filter.filters.length);
    },
    label() {
      if (this.options.showFiltersCount) {
        return `${this.filter.value} (${this.filter.count})`;
      }
      return this.filter.value;
    },
    reloading() {
      return this.$store.getters.reloading;
    },
    model: {
      get() {
        return this.filter.selected;
      },
      set(value) {
        this.setFilterValue(this.filter, value);

        if (this.options.filterParentsExcludeChildren && value) {
          if (this.hasChildren) {
            const recurse = (filter) => {
              this.setFilterValue(filter, false);

              if (filter.filters && filter.filters.length) {
                filter.filters.forEach(recurse);
              }
            }

            this.filter.filters.forEach(recurse);
          }
        }
      },
    },
  },
  methods: {
    parseTreeActiveState(filters) {
      let hasSelections = false;
      filters.forEach((filter) => {
        if (filter.selected) hasSelections = true;
        else if (filter.filters && filter.filters.length) {
          if (this.parseTreeActiveState(filter.filters)) hasSelections = true;
        }
      });
      return hasSelections;
    },
  },
  watch: {
    reloading() {
      if (this.hasChildren) {
        this.active = this.parseTreeActiveState(this.filter.filters);
      }
    },
  },
  created() {
    if (this.hasChildren) {
      if (this.parseTreeActiveState(this.filter.filters)) {
        this.active = true;
      }
    }
  },
};
